import {useRankedBrandTraits} from "./brand-traits";
import {useEffect, useState} from "react";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {httpsCallable} from "firebase/functions";
import {functions} from "hooks/firebase";
import {RecommendedColors3Request, RecommendedColors3Response} from "data/models/shared/recommended-colors3";


export function useRecommendedColors3(): [RecommendedColors3Response | null, boolean, Error | null] {
  const [rankedBrandTraits, rankedTraitsLoading, rankedTraitsError] = useRankedBrandTraits();
  const [error, setError] = useState<Error | null>(null);

  const [recommendedColors, setRecommendedColors] = useState<RecommendedColors3Response | null>(null);


  useEffect(() => {
    const anError = (
        rankedTraitsError
    );
    if (!isNullOrUndefined(anError)) {
      setError(anError);
      return;
    }
    if (rankedTraitsLoading) {
      return;
    }
    if (isNullOrUndefined(rankedBrandTraits)) {
      return;
    }

    const recommendedColors3Request = {
      rankedBrandTraits: rankedBrandTraits?.slice(0, 3).map(trait => trait.traitKey),
    };

    const recommendedColors3Function = httpsCallable<RecommendedColors3Request, RecommendedColors3Response>(functions, 'recommendedColors3');

    recommendedColors3Function(recommendedColors3Request).then(result => {
      setRecommendedColors(result.data);
      setError(null);
    }).catch((error) => {
      setError(error as Error);
    });

  }, [
    // masterLoading,
    rankedBrandTraits, rankedTraitsLoading, rankedTraitsError,
  ]);

  return [recommendedColors, rankedTraitsLoading, error];
}

